
<fieldset style="border: 0; font-family: roboto-flex; margin-right: 10px; min-height: 55px; padding-left: 0;">
  @if (isPhone) {
    <legend style="font-size: small; font-weight: lighter">Followers</legend>
  }
  <mat-chip-listbox aria-label="Followers">
    @for (follower of chatField.chat?.followers; track $index) {
      <mat-chip  (removed)="remove(follower)" [attr.data-follower-chip]="follower.personFullName">
         <!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
         <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
         <span style="cursor: pointer" (click)="click(follower)">{{follower.personFullName}}</span>
        @if (allowRemove) {
          <button matChipRemove data-follower-remove>
            <mat-icon>cancel</mat-icon>
          </button>
        }
      </mat-chip>
    }
  </mat-chip-listbox>
</fieldset>
